<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="700" v-if="dialog" scrollable>
			<v-card>
				<v-card-title class="headline">Tambah Armada</v-card-title>
				<!-- <v-card-title class="headline" v-else>Edit Pengguna</v-card-title> -->
				<v-card-text class="pb-2">
					<v-form ref="formArmada">
						<v-card
							outlined
							class="pa-2 mb-4"
						>
							<v-card-subtitle class="pb-0 px-2"><h3>Info Armada</h3></v-card-subtitle>
							<v-row>
								<v-col cols="6">
									<div class="pa-2">
										<v-text-field v-model="params.registration_number" label="Nomor Kendaraan" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.registration_number=''" :error-messages="responseError.registration_number" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-text-field>
									</div>
								</v-col>
								<v-col cols="6">
								<div class="pa-2">
									<v-autocomplete v-model="params.condition" label="Kondisi Kendaraan" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.condition=''" :error-messages="responseError.condition" :items="conditionList" outlined class="text-body-1" dense hide-details="auto" no-data-text="Tidak ada data" color="primary lighten-1"></v-autocomplete>
								</div>
								</v-col>
							</v-row>
							<v-divider></v-divider>

							<v-row>
								<v-col cols="6">
									<div class="pa-2">
										<v-autocomplete v-model="params.type" label="Tipe Kendaraan" :items="typeList" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.type=''" :error-messages="responseError.type" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-autocomplete>
									</div>
									<div class="pa-2">
										<v-text-field v-model="params.brand" label="Brand Kendaraan" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.brand=''" :error-messages="responseError.brand" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-text-field>
									</div>
									<div class="pa-2">
										<v-text-field v-model="params.model" label="Varian Kendaraan" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.model=''" :error-messages="responseError.model" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-text-field>
									</div>
								</v-col>
								
								<v-col cols="6">
									<div class="pa-2">
										<v-text-field v-model="params.color" label="Warna Kendaraan" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.color=''" :error-messages="responseError.color" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-text-field>
									</div>
									<div class="pa-2">
										<v-autocomplete v-model="params.production_year" label="Tahun Produksi" :items="yearList" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.production_year=''" :error-messages="responseError.production_year" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-autocomplete>
									</div>
								</v-col>
							</v-row>
						</v-card>

						<v-card
							outlined
							class="pa-2 mb-4"
						>
							<v-card-subtitle class="pb-0 px-2"><h3>Spesifikasi Armada</h3></v-card-subtitle>
							<v-row>
								<v-col cols="6">
									<div class="pa-2">
										<v-currency-field :min="0" :decimalLength="2" v-model="params.max_width_centimeter" hint="Dalam cm" label="Maksimal Lebar" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.max_width_centimeter=''" :error-messages="responseError.max_width_centimeter" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
									</div>
									<div class="pa-2">
										<v-currency-field :min="0" :decimalLength="2" v-model="params.max_height_centimeter" hint="Dalam cm" label="Maksimal Tinggi" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.max_height_centimeter=''" :error-messages="responseError.max_height_centimeter" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
									</div>
									<div class="pa-2">
										<v-currency-field :min="0" :decimalLength="2" v-model="params.max_depth_centimeter" hint="Dalam cm" label="Maksimal Kedalaman" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.max_depth_centimeter=''" :error-messages="responseError.max_depth_centimeter" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
									</div>
									<div class="pa-2">
										<v-currency-field :min="0" :decimalLength="2" v-model="params.max_weight_kilogram" hint="Dalam Kg" label="Maksimal Berat" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.max_weight_kilogram=''" :error-messages="responseError.max_weight_kilogram" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
									</div>
								</v-col>

								<v-col cols="6">
									<div class="pa-2">
										<v-autocomplete v-model="params.fuel_type" label="Bahan Bakar" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.fuel_type=''" :error-messages="responseError.fuel_type" :items="fuelList" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-autocomplete>
									</div>

									<div class="pa-2">
										<v-currency-field :min="0" :decimalLength="2" v-model="params.max_fuel_liter" hint="Dalam Liter" label="Kapasitas Maks. Bahan Bakar" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.max_fuel_liter=''" :error-messages="responseError.max_fuel_liter" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
									</div>
								</v-col>
							</v-row>
						</v-card>	

						<!-- <v-row>
							<v-col cols="6" class="text-center">
								<div class="pb-3">
									<v-currency-field v-model="params.depreciation_expense" label="Penyusutan per tahun" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.depreciation_expense=''" :error-messages="responseError.depreciation_expense" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
								</div>
							</v-col>
							<v-col cols="6" class="text-center">
								<div class="pb-3">
									<v-currency-field :min="0" v-model="params.maintenance_cycle_month" hint="Dalam bulan" label="Jangka Waktu Service" validate-on-blur :rules="[inputrules.required]" @focus="() => responseError.maintenance_cycle_month=''" :error-messages="responseError.maintenance_cycle_month" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
								</div>
							</v-col>
							<v-col cols="6" class="text-center">
								<div class="pb-3">
									<v-currency-field :min="0" :decimalLength="2" v-model="params.maintenance_expense" validate-on-blur label="Biaya Service" :rules="[inputrules.required]" @focus="() => responseError.maintenance_expense=''" :error-messages="responseError.maintenance_expense" outlined class="text-body-1" dense hide-details="auto" color="primary lighten-1"></v-currency-field>
								</div>
							</v-col>
						</v-row> -->
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="modalHide()">Batal</v-btn>
					<v-btn dark color="primary lighten-1" depressed class="text-capitalize" @click="simpan()">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			action: '',
			dialog: false,
			menu:false,
			conditionList: [
			{ value: "excellent" , text: "Prima"},
			{ value: "good" , text: "Baik"},
			{ value: "fair" , text: "Cukup"},
			{ value: "poor" , text: "Buruk"},
			],
			fuelList: ['Pertalite', 'Solar', 'Gas', 'Listrik'],
			typeList: [
			{value: "pick_up", text: "Pick Up"},
			{value: "grand_max", text: "Grand Max"},
			{value: "box_cde", text: "Box CDE (Engkel)"},
			{value: "box_cdd", text: "Box CDD (Double)"},
			{value: "fuso", text: "Fuso"},
			{value: "tronton", text: "Tronton"},
			{value: "wingbox", text: "Wingbox"},
			{value: "trailer", text: "Trailer"},
			{value: "container", text: "Container"},
			{value: "other", text: "Lainnya"}
			],
			params: {
				type: '',
				brand: '',
				model: '',
				color: '',
				registration_number: '',
				production_year: '',
				max_width_centimeter: '',
				max_height_centimeter: '',
				max_depth_centimeter: '',
				max_weight_kilogram: '',
				max_fuel_liter: '',
				fuel_type: '',
				condition: '',
				id: ''
			},
		}
	},
	props: {
		propAdd: String,
		val: Object,
	},
	computed: {
		...mapState('armada', ['responseError']),

		yearList() {
			let dateNow = new Date();
			let year = dateNow.getFullYear();

			var array = [];
			var i;
			for (i = 1990; i <= year; i++) {
				array.push(i)
			}
			return array;
		}
	},
	methods: {
		modalShow(data) {
			this.dialog = true
			Object.assign( this.params , data )
		},
		modalHide() {
			this.dialog = false
			this.reset()
		},
		reset() {
			this.params.id = ''
			this.params.type = ''
			this.params.brand = ''
			this.params.model = ''
			this.params.color = ''
			this.params.registration_number = ''
			this.params.production_year = ''
			this.params.max_width_centimeter = ''
			this.params.max_height_centimeter = ''
			this.params.max_depth_centimeter = ''
			this.params.max_weight_kilogram = ''
			this.params.max_fuel_liter = ''
			this.params.fuel_type = ''
			this.params.condition = ''
		},
		simpan() {
			if (this.$refs.formArmada.validate()) {
				this.$emit('action', this.params)
			}
		}
	},
	watch: {
		val () {
			if (Object.keys(this.val).length > 0) {
				this.params.id = this.val.vehicle_id
				this.params.type = this.val.vehicle_type
				this.params.brand = this.val.vehicle_brand
				this.params.model = this.val.vehicle_model
				this.params.color = this.val.vehicle_color
				this.params.registration_number = this.val.vehicle_registration_number
				this.params.production_year = this.val.vehicle_production_year
				this.params.max_width_centimeter = this.val.vehicle_max_width_centimeter
				this.params.max_height_centimeter = this.val.vehicle_max_height_centimeter
				this.params.max_depth_centimeter = this.val.vehicle_max_depth_centimeter
				this.params.max_weight_kilogram = this.val.vehicle_max_weight_kilogram
				this.params.max_fuel_liter = this.val.vehicle_max_fuel_liter
				this.params.fuel_type = this.val.vehicle_fuel_type
				this.params.condition = this.val.vehicle_condition
			} else {
				this.reset()
			}
		}
	},
	created() {
	}
};
</script>